import BordOneToneIcon from '../../../../../../../../components/NudosComponents/BordOneToneIcon/BordOneToneIcon';
import { TbordOneToneIcon } from '../../../../../../../../components/NudosComponents/BordOneToneIcon/BordOneToneIcon.types';
import UserInfo from '../../../../../../../../components/UserInfo/UserInfo';
import { IConfigurationData } from '../../../../../../../../types/product.configuration.types';
import { getConfigClass } from '../../../../../../../../utils/configurations';
import { copyClipboard } from '../../../../../../../../utils/copyClipboard';
import { displaySuccessNotification } from '../../../../../../../../utils/displayNudosStandardNotifications';
import { formatDateToPicker } from '../../../../../../../../utils/formatDatesAndHours';
import useConfigurationGlobalState from '../../../configurationGlobalState';
import './ConfigurationListingCard.scss';

interface ConfigurationListingCardProps {
  configuration: IConfigurationData;
}

const ConfigurationListingCard = ({ configuration }: ConfigurationListingCardProps) => {
  const {
    setIsToolsAsociatedConfigModalOpen,
    setConfigUnit,
    setIsInactiveConfigModalOpen,
    setIsDeleteConfigModalOpen,
    setIsReviewConfigModalOpen
  } = useConfigurationGlobalState();

  const isActiveStyle = configuration.isActive ? 'isActive' : 'isInactive';
  const defaultVariantIconByDinamicConfigurationIcons = 'tool' as TbordOneToneIcon;

  const handleOpenToolsConfigModal = () => {
    setIsToolsAsociatedConfigModalOpen(true);
    setConfigUnit(configuration);
  };

  const handleOpenReviewConfigModal = () => {
    setIsReviewConfigModalOpen(true);
    setConfigUnit(configuration);
  };

  const handleConfigAction = () => {
    if (!configuration.isActive) return;

    setConfigUnit(configuration);

    if (configuration?.tools?.length > 0) {
      setIsInactiveConfigModalOpen(true);
    } else {
      setIsDeleteConfigModalOpen(true);
    }
  };

  const handleCopyConfigurationId = () => {
    copyClipboard({ text: String(configuration.id) });
    displaySuccessNotification({
      customJSXMessage: <>ID de configuración copiado con éxito</>,
      duration: 3000
    });
  };

  const getConfigActionTitle = (configuration: IConfigurationData) => {
    if (configuration?.tools?.length > 0 && configuration?.isActive) return 'Inactivar configuración';
    if (configuration?.tools?.length > 0 && !configuration?.isActive) return 'Configuración inactiva';

    return 'Eliminar configuración';
  };

  return (
    <>
      <div className="configurationListingCard">
        <div className={`tableField id cursor-pointer ${isActiveStyle}`} onClick={handleCopyConfigurationId}>
          {configuration.id}
        </div>
        <div className={`tableField name ${isActiveStyle}`}>{configuration?.name ?? 'No disponible'}</div>
        <div className={`tableField createdBy ${isActiveStyle}`}>
          <UserInfo
            firstName={configuration?.author?.firstName ?? ''}
            lastName={configuration?.author?.lastName ?? ''}
            email={configuration?.author?.email ?? 'No disponible'}
            profilePhoto={configuration?.author?.photoUrl ?? ''}
          />
        </div>
        <div className={`tableField class ${isActiveStyle}`}>
          <BordOneToneIcon
            variant={
              getConfigClass(configuration?.configClassId)?.variantIcon ??
              (defaultVariantIconByDinamicConfigurationIcons as TbordOneToneIcon)
            }
            standardSize={10}
          />
          <div>{getConfigClass(configuration?.configClassId)?.name}</div>
        </div>
        <div className={`tableField tools ${isActiveStyle}`} onClick={handleOpenToolsConfigModal}>
          <span>{`${configuration?.tools?.length} Unidades`}</span>
          <BordOneToneIcon variant="arrowHeadRight" standardSize={10} />
        </div>
        <div className={`tableField createdAt`}>{formatDateToPicker(configuration?.createdAt)}</div>
        <div className={`tableField actions`}>
          <div className="reviewButton" onClick={handleOpenReviewConfigModal}>
            Revisar
          </div>
          <div
            className={`inactiveOrDeleteButton ${isActiveStyle}`}
            onClick={handleConfigAction}
            title={getConfigActionTitle(configuration)}
          >
            <BordOneToneIcon variant="trash" standardSize={10} />
          </div>
        </div>
      </div>
    </>
  );
};

export default ConfigurationListingCard;
